import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Customer } from '../models/customer.model';
import { PaginatedList } from '../models/paginatedList.model';
import { CustomerRevenueSummary } from '../models/view-models/customerRevenueSummary.viewmodel';
import { DateRangeEnum } from '../models/enums/dateRange.enum';
import { RestResponse } from '../models/restResponse.mode';
import { environment } from '../../environments/environment';

export interface CustomerCreatedPayload {
  id: number;
  fullName: string;
  cpf: string;
  phone: string;
  active: boolean;
}

function mapPayloadToCustomer(d: CustomerCreatedPayload): Customer {
  return {
    id: d.id,
    status: d.active ? 'active' : 'inactive',
    active: d.active,
    fullName: d.fullName,
    cpf: d.cpf ?? '',
    phone: d.phone ?? '',
    address: '',
    addressComplement: '',
    addressNumber: '',
    birthDay: new Date(),
    cashBack: 0,
    cep: '',
    city: '',
    contact: '',
    creditLimit: 0,
    district: '',
    dueDay: 0,
    email: '',
    homePhone: '',
    installmentPriceTable: false,
    moneyPriceTable: false,
    nickName: '',
    observations: '',
    order: null as unknown as Customer['order'],
    rg: '',
    situation: '',
    state: '',
    usePriceTable: false,
    whatsApp: '',
    wholeSalePriceTable: false
  };
}

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  private readonly baseUrl = `${environment.base_url}/customers`;

  constructor(private http: HttpClient) {}

  getAll(search: string, active: boolean | null, page: number): Observable<RestResponse<Customer[]>> {
    console.log(search);
    return this.http.get<RestResponse<Customer[]>>(`${this.baseUrl}/list?search=${search}&active=${active}&page=${page}`); 
  }

  getById(id: number): Observable<RestResponse<Customer>> {
    return this.http.get<RestResponse<Customer>>(`${this.baseUrl}/find/${id}`);
  }

  getByCpf(cpf: string): Observable<RestResponse<Customer>> {
    return this.http.get<RestResponse<Customer>>(`${this.baseUrl}/find-by-cpf/${cpf}`);
  }

  create(customer: Customer): Observable<Customer> {
    return this.http.post<RestResponse<CustomerCreatedPayload>>(`${this.baseUrl}/save`, customer).pipe(
      map((res) => {
        if (!res?.data?.id) {
          throw new Error('Resposta inválida ao salvar cliente.');
        }
        return mapPayloadToCustomer(res.data);
      })
    );
  }

  update(id: number, customer: Customer): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/update/${id}`, customer);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
  
  getCustomersRevenueSummary(search: string, cpf: string, id: number | null, status: string, dateRange: DateRangeEnum, city: string | null, page: number, includeNoFinancials?: boolean | undefined, active?: boolean | undefined): Observable<RestResponse<CustomerRevenueSummary[]>> {
    let params: any = { status, cpf, id, search, dateRange, page };
    
    if (city) {
      params.city = city;
    }
    
    if (includeNoFinancials !== undefined) params.includeNoFinancials = includeNoFinancials.toString();
    if (active !== undefined) params.active = active.toString();
    return this.http.get<RestResponse<CustomerRevenueSummary[]>>(`${this.baseUrl}/list_customer_revenue_summary`, {params});

  }
}
